import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('discardForwardingOption')(function discardForwardingOption() {
    store.choiceGroupSelection = null;
    store.forwardingEmailAddress = null;
    store.keepCopy = null;
});
//# sourceMappingURL=discardForwardingOption.js.map